import { blockchainsConnectionInfo } from '@common/blockchains/blockchains.prod';
import { eOttPermission } from '@common/request_enums';

export const environment = {
    production: true,
    stage: true,
    api_host: 'https://api-stage.cyberwallet.ai',
    invoiceOrigin: 'https://billing-service-stage.azurewebsites.net/pay',
    ...blockchainsConnectionInfo,

    networksBoolean: {
        1: false,//ethereum
        5: true,//goerli
        56: false,//bsc_main
        97: true,//bsc_test
        137: false,//polygon_main
        80002: true,//polygon_test
        943: false,//pulseChain_test
        11155111: true
    },
    etherScanApi: 'WIDK2MPTVHH1TMVYJICS5JDZVMKUC3ZIJF',
    alchemy: {
        kovan: [ 'https://eth-kovan.alchemyapi.io/v2/qoVIoN0TZVyoIdsIZJGxuUxnTSfK0lX0', 'https://eth-kovan.alchemyapi.io/v2/7NdSx33E9yNicR0xIFi85jU8G7pEfLY1', 'https://eth-kovan.alchemyapi.io/v2/V5qpPCasKHZ1MnYZLRz0gInhVXeaRh0V' ],
        ropsten: [ 'https://eth-ropsten.alchemyapi.io/v2/qoVIoN0TZVyoIdsIZJGxuUxnTSfK0lX0', 'https://eth-ropsten.alchemyapi.io/v2/7NdSx33E9yNicR0xIFi85jU8G7pEfLY1', 'https://eth-ropsten.alchemyapi.io/v2/V5qpPCasKHZ1MnYZLRz0gInhVXeaRh0V' ],
        mainnet: [ 'https://eth-mainnet.alchemyapi.io/v2/tyC39MlQKMjgqUmAy2y5ad05Z8bv-Ca9', 'https://eth-mainnet.alchemyapi.io/v2/jJp3JiHUQnj1BWEone9qK162Uosvl7y-', 'https://eth-mainnet.alchemyapi.io/v2/p6mDs9bExjHJA5TwQmRKIaYPeZg7UYUs', 'https://eth-mainnet.alchemyapi.io/v2/_QA-RfVLP8DlzdUIWBX39-MyFgDtkpN0' ]
    },
    etherContractsApi: {
        mainnet: 'https://api-cn.etherscan.com/api',
        kovan: 'https://api-kovan.etherscan.io/api',
        ropsten: 'https://api-ropsten.etherscan.io/api',
        cn: 'https://api-cn.etherscan.com/api',
    },
    bsc: {
        mainnet: [
            'https://bsc-dataseed.binance.org/',
            'https://bsc-dataseed1.defibit.io/',
            'https://bsc-dataseed1.ninicoin.io/'
        ],
        testnet: [
            'https://data-seed-prebsc-1-s1.binance.org:8545/',
            'https://data-seed-prebsc-1-s2.binance.org:8545/',
            'https://data-seed-prebsc-2-s2.binance.org:8545/',
            'https://data-seed-prebsc-1-s3.binance.org:8545/',
            'https://data-seed-prebsc-2-s3.binance.org:8545/'
        ]
    },
    bscContractsApi: {
        mainnet: 'https://api.bscscan.com/api',
        testnet: 'https://api-testnet.bscscan.com/api'
    },
    bscExplorerApi: '85UGHD22WX3FE7P1XRINNS9TSI3WQDT7HT',
    polygon: {
        mainnet: [
            'https://rpc-mainnet.maticvigil.com',
            'https://polygon-rpc.com',
            'https://rpc-mainnet.matic.quiknode.pro',
            'https://matic-mainnet.chainstacklabs.com',
        ],
        testnet: [
            'https://polygon-mumbai.g.alchemy.com/v2/hnyR1sr_yWa3gzSJ0-WF-66N429dVkrf',
            'https://polygon-mumbai.g.alchemy.com/v2/cg1QXJzSBIJUIU7TUYXEDJzRKGR-1Icz/',
        ],
    },
    polygonContractsApi: {
        mainnet: 'https://api.polygonscan.com/api',
        testnet: 'https://api-testnet.polygonscan.com/api',
    },
    polygonExplorerApi: 'IY3Z1D4V7XBG8PJBAETCP5D25XAJI35HXE',
    pulseChain: {
        mainnet: [
        ],
        testnet: [
            "https://rpc.v4.testnet.pulsechain.com",
        ]
    },
    pulseChainContractsApi: {
        // mainnet: '',
        testnet: 'https://scan.v4.testnet.pulsechain.com/api',
    },
    idbStoreName: 'hyper-wallets',
    idbNFTStoreName: 'idb-nft',
    hyper_id: {
        host: 'https://login-stage.hypersecureid.com',
        resourceServer: 'https://rs1-stage.hypersecureid.com',
        backup_api: 'https://backup-service-stage-v2.azurewebsites.net/api/'
    },
    networks: {
        ethereum: 'kovan',
        bsc: 'mainnet',
        polygon: 'testnet',
        pulsechain: 'testnet'
    },
    ott: {
        authenticationRequired: [ //todo: rename to notification ?
            eOttPermission.keys
        ]
    },
    authentication: {
        mfa: true,
        web_authn: true
    },
    session: {
        offline_timeout_for_lock: 1000 * 60 * 60,
        inactivity_timeout_for_lock: 1000 * 60 * 60,
        update_security_timeout: 1000 * 60 * 5
    },
    actions: {
        code_length: 2,
        unlock_expiration_timeout: 1000 * 60 * 5,
        key_approve_timeout: 1000 * 60 * 5
    },
    markets: {
        mxc: {
            access_key: 'mx0gcTZXQgjkWQb4Ni',
            secret_key: null
        }
    },
    spacebox_origin: 'https://spaced-bbox-stage.azurewebsites.net',
    resourceServerTimeoutMs: 30_000,
    // pushNotificationPubKey: 'BDdTxZCMo4E8kA-aRDLXZlRRpHS1vXtoDecb-Xa7Pg7Orv4cJ1L1cMZLtinfXirJBnX59y0wVT3h3gmzDqm6-04',
    pushNotificationPubKey: 'BC_bnxOf-VWK4ClVHUhGPpK0_8CsdsNFBMZyLJujgJPKvzi7PEGSyd8Kr_jA0rD0ieb_NkOPo7WHbJhc17tf9_c',
    usePushNotification: true,
    priceServiceHost: 'https://prices.cyberwallet.ai'
};
